module.exports = __webpack_public_path__ + "img/running-light-green.599f4302.png";